import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { RequestStatusBadge } from "../../badge/RequestStatusBadge";
import { SuppliesRequestStatus } from "@/constants/entity-status";
import { DepositoSelector } from "../DepositoSelector";

interface Props {
  fechaEntrega?: string;
  titularCuenta?: string;
  destino?: string;
  nombreDeposito?: string;
  showDepositoSelector?: boolean;
  depositoItems?: { label: string; value: string }[];
  loadingDepositos?: boolean;
  savingDeposito?: boolean;
  onSaveDeposito?: (idDeposito: number) => Promise<void>;
  contacto?: string;
  nombreContacto?: string;
  estadoDescripcion?: string;
}

export const FuelSlotRequestMainData = ({
  fechaEntrega,
  titularCuenta,
  destino,
  nombreDeposito,
  showDepositoSelector,
  depositoItems,
  loadingDepositos,
  savingDeposito,
  onSaveDeposito,
  contacto,
  nombreContacto,
  estadoDescripcion,
}: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="10px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Fecha de entrega:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">
                {fechaEntrega ? dayjs(fechaEntrega).format("DD/MM/YYYY") : "-"}
              </Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Cuenta:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{titularCuenta ?? "-"}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Destino:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{destino ?? "-"}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Depósito:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              {nombreDeposito ? (
                <Text className="account-value-label">{nombreDeposito}</Text>
              ) : showDepositoSelector ? (
                <DepositoSelector
                  items={depositoItems ?? []}
                  loading={loadingDepositos}
                  saving={savingDeposito}
                  onSave={onSaveDeposito}
                />
              ) : (
                <Text className="account-value-label">-</Text>
              )}
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>

      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform="uppercase"
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>

          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-title-label">Contacto (Teléfono):</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
              display="flex"
              alignItems="center"
            >
              <Text className="account-value-label">{contacto ?? "-"}</Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Contacto (Nombre):</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px" minWidth={0}>
              <Text
                className="account-value-label"
                truncate
                title={nombreContacto ?? "-"}
              >
                {nombreContacto ?? "-"}
              </Text>
            </GridItem>

            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text as="span" className="account-value-label">
                <RequestStatusBadge
                  status={estadoDescripcion as SuppliesRequestStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
